import { render, staticRenderFns } from "./changeMobile.vue?vue&type=template&id=204e63f8&scoped=true"
import script from "./changeMobile.vue?vue&type=script&lang=js"
export * from "./changeMobile.vue?vue&type=script&lang=js"
import style0 from "./changeMobile.vue?vue&type=style&index=0&id=204e63f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e63f8",
  null
  
)

export default component.exports